export const PARTNER_REF_KEY = 'thulium_partner_ref'
export const VALUE_TRACK_KEY = 'thulium_value_track'

const get = (key: string): string | undefined => {
    try {
        const cookies = document.cookie.split(';')
        const cookie = cookies.find((cookie) => cookie.includes(key))
        return cookie.trim().replace(`${key}=`, '')
    } catch (e) {
        return undefined
    }
}

const set = (key: string, value: string, days: number): void => {
    try {
        const expiration = days ? calcExpiration(days) : ''
        document.cookie = `${key}=${value};path=/;${expiration}`
    } catch (e) {
        //Ignore for now
    }
}

const remove = (name: string): void => {
    document.cookie = `${name}=; Max-Age=0; path=/; domain=${window.location.hostname}`
}

const calcExpiration = (days: number): string => {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    return `expires=${date.toUTCString()};`
}

const cookies = {
    get,
    set,
    remove,
}

export default cookies
